import moment from 'moment'
import store from '@/store'

export const TypeEnum = {
  text: 'text',
  video: 'video',
  image: 'image',
  document: 'document'
}

export const StatusEnum = {
  broadcast: 'broadcast',
  bot: 'bot',
  manuanling: 'manuanling',
  manualed: 'manualed',
  closed: 'closed'
}

export const GoogleMapsKey = 'AIzaSyCrSGJ_aDX8-GTcm9G8tVCdtPOC8AtXcbM'

export const getLastMessage = (val) => {
  let text = ''
  switch (val.type) {
  case TypeEnum.text:
    text = val[TypeEnum.text]
    break

  case TypeEnum.document:
    text = '[Document]'
    break

  case TypeEnum.image:
    text = '[Image]'
    break

  case TypeEnum.video:
    text = '[Video]'
    break

  default:
    text = `[${val.type.charAt(0).toUpperCase() + val.type.slice(1)}]`
    break
  }

  return text
}

export function conversionUtcDate(time) {
  // let TZ = curTimezone();
  let timeStr = time ? moment(time) : moment()
  // if(TZ){
  //   timeStr = dayjs(time).tz(TZ)
  // }else{
  //   timeStr = dayjs(time)
  // }
  return timeStr
}

export function isYestday(timeValue) { // 是否为昨天
  const date = new Date(timeValue)
  const today = new Date()
  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth()) {
    if (date.getDate() - today.getDate() === -1) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function formatListTime (time) {
  if (!time) return time
  if (time < 9999999999) time = time * 1000
  let _Time = conversionUtcDate(time).utcOffset(store.getters.usertime.time)
  if (isYestday(time)) {
    return this.$t('global.yesterday')
  }
  if (conversionUtcDate().format('YYYY-MM-DD') === conversionUtcDate(time).format('YYYY-MM-DD')) {
    return _Time.format('HH:mm')
  } else {
    return _Time.format('DD-MM-YY')
  }
}

export function formatMsgTime (time) {
  if (!time) return time
  if (time < 9999999999) time = time * 1000
  let _Time = conversionUtcDate(time).utcOffset(store.getters.usertime.time)
  if (conversionUtcDate().format('YYYY-MM-DD') === conversionUtcDate(time).format('YYYY-MM-DD')) {
    return _Time.format('HH:mm')
  } else {
    return _Time.format('DD-MM-YY HH:mm')
  }
}

export const scrollBottom = async (dom, behavior = 'smooth') => {
  let bottomH = dom.scrollHeight - dom.offsetHeight
  dom.scroll({
    top: bottomH,
    behavior: behavior
  })
}

export const openMessage = (status = '', bool) => {
  let text = ''
  switch (true) {
  case StatusEnum.manualed === (status) && bool:
    text = 'teamInbox.duihua'
    break
  case StatusEnum.manualed === (status) && !bool:
    text = 'teamInbox.manualedType'
    break
  case StatusEnum.manuanling === (status) :
    text = 'teamInbox.manuanlingType'
    break
  case StatusEnum.closed === (status) :
    text = 'teamInbox.closedType'
    break
  case StatusEnum.broadcast === (status) :
    text = 'teamInbox.broadcastType'
    break

  default:
    break
  }

  return text
}

// 下载文件
export function downloadFileUrl (url, name) {
  let fileName = name || url.split('/').slice(-1)[0]
  fetch(url).then(res => res.blob()).then(blob => {
    const a = document.createElement('a')
    const objectUrl = window.URL.createObjectURL(blob)
    a.download = fileName
    a.href = objectUrl
    a.click()
    window.URL.revokeObjectURL(objectUrl)
    a.remove()
  }).catch(() => {})
}

export function resourceToBase64(url) {
  return fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () =>
          resolve({ url: reader.result, blob: blob })
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    })
}

export const isTest = process.env.NODE_ENV === 'development' || window.location.host.includes('internal')

export const getSrcGoogle = async (g) => {
  var h,
    a,
    k,
    p = 'The Google Maps JavaScript API',
    c = 'google',
    l = 'importLibrary',
    q = '__ib__',
    m = document,
    b = window
  b = b[c] || (b[c] = {})
  var d = b.maps || (b.maps = {}),
    r = new Set(),
    e = new URLSearchParams(),
    u = () =>
      h ||
      (h = new Promise(async (resolve, reject) => {
        await (a = m.createElement('script'))
        e.set('libraries', [...r] + '')
        for (k in g) {
          e.set(
            k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
            g[k]
          )
        }
        e.set('callback', c + '.maps.' + q)
        a.src = `https://maps.${c}apis.com/maps/api/js?` + e
        d[q] = resolve
        a.onerror = () => (h = reject(Error(p + ' could not load.')))
        a.nonce = m.querySelector('script[nonce]').nonce || ''
        m.head.append(a)
      }))
  d[l]
    ? console.warn(p + ' only loads once. Ignoring:', g)
    : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)))

  await loadSDK(document, 'script')
}

export const loadSDK = (d, s) => {
  return new Promise((resolve) => {
    let js,
      fjs = d.getElementsByTagName(s)[0]

    js = d.createElement(s)
    js.src = `https://maps.googleapis.com/maps/api/js?key=${GoogleMapsKey}&libraries=places`
    fjs.parentNode.insertBefore(js, fjs)
    js.onload = function () {
      resolve('ok')
    }
  })
}

export function bindGoogleMaps() {
  getSrcGoogle({
    key: GoogleMapsKey,
    v: 'weekly'
    // libraries: "places",
  })
}

export function getFirstImg(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    let scale = 1
    const video = document.createElement('VIDEO')
    video.preload = true
    video.autoplay = true
    video.muted = true
    video.src = url
    function initialize() {
      video.currentTime = 1 // 获取第一帧的图片
      video.addEventListener('loadeddata', function () {
        captureImage()
      })
    }

    function captureImage() {
      let canvas = document.createElement('canvas')
      canvas.width = video.videoWidth * scale
      canvas.height = video.videoHeight * scale
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
      const dataBase64 = canvas.toDataURL('image/png') // 完成base64图片的创建
      if (dataBase64) {
        const imgFile = dataURLtoFile(dataBase64, `${new Date().getTime()}.png`)
        let duration = video.duration
        resolve({
          imgFile, duration
        }, dataBase64)
      }
    }
    initialize()
  })
}

export function dataURLtoFile(dataBase64, filename) {
  const arr = dataBase64.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export function getVideoDuration(file) {
  return new Promise((resolve, reject) => {
    let url = URL.createObjectURL(file)
    let audioElement = new Audio(url)
    audioElement.addEventListener('loadedmetadata', function() {
      let result = audioElement.duration
      resolve(result)
    })
    audioElement.addEventListener('error', (error) => reject(error))
  })
}



// WEBPACK FOOTER //
// ./src/views/Chatbot/teamInbox/func/index.js